






















































import {Component, Prop, Vue} from "vue-property-decorator";
import LanguagePicker, {Language} from "./LanguagePicker.vue";
import {loadLanguageAsync} from "../I18n";

export interface NavigationObject {
    label: string;
    link: string;
    classes: string[];
    styles: string[];
}

@Component({
    components: {
        LanguagePicker
    }
})
export default class Navigation extends Vue {
    @Prop({
        type: Array,
        required: true
    })
    public items!: NavigationObject[];

    public mounted() {
        $("body").scrollspy({
            target: "nav",
            offset: 56
        });
    }

    public hoverImage(ev: MouseEvent) {
        const target = ev.target as Element;
        const hoversrc = target.getAttribute('hoversrc');
        if (hoversrc == null) return;
        const src = target.getAttribute('src');
        if (src == null) return;
        target.setAttribute('orgsrc', src)
        target.setAttribute('src', hoversrc);
    }

    public unhoverImage(ev: MouseEvent) {
        const target = ev.target as Element;
        const orgsrc = target.getAttribute('orgsrc');
        if (orgsrc == null) return;
        target.setAttribute('src', orgsrc);
    }


    public onClick() {
        $(".navbar-collapse").collapse("hide");
    }

    public computeClassesFor(item: NavigationObject) {
        return ["nav-link"].concat(item.classes);
    }

    public concatStyles(item: NavigationObject) {
         var style = '';
         console.log(item.styles)
        item.styles.forEach(element => {
            style = style + element + " ";
        });

        console.log(style);
        return style;
    }

    public showToast() {
        window.location.href = "https://www.glastrinkhalm.shop/";
    }

    private selectLanguage(language: Language) {
        history.pushState({}, "", "/" + language.code);
        loadLanguageAsync(language.code);
    }
}
